import { Controller } from "@hotwired/stimulus"
import ace from "ace-builds"
import DOMPurify from "dompurify"
import "ace-builds/src-noconflict/mode-html"
import "ace-builds/src-noconflict/theme-monokai"

export default class extends Controller {
  static targets = [ "editor", "htmlInput", "textInput", "htmlOutput", 
    "textOutput", "wrapper", "fullScreenIcon" ]

  static classes = [ "fullScreen" ]

  connect() {
    this.aceEditor = ace.edit(this.editorTarget)
    this.aceEditor.setTheme("ace/theme/monokai")
    this.aceEditor.session.setMode("ace/mode/html")

    this.aceEditor.setOptions({
      placeholder: "Paste your HTML code here...",
      fontSize: "14px",
      showPrintMargin: false,
      useSoftTabs: true
    })

    if (this.hasHtmlInputTarget) {
      this.aceEditor.setValue(this.htmlInputTarget.value, -1)
      
      // Update hidden input on change
      this.aceEditor.session.on('change', () => {
        const sanitized = String(DOMPurify.sanitize(this.aceEditor.getValue(), {
          WHOLE_DOCUMENT: true,       // Preserves <html>, <head>, and <body> tags
          FORCE_BODY: true,           // Ensures stable, safe parsing behavior
          ADD_TAGS: ['style', 'meta', 'link'], // Allows styling, responsive viewports, and fonts
          ADD_ATTR: ['target', 'style', 'href', 'rel'], // Crucial for links and inline styles
        }))

        this.htmlOutputTarget.srcdoc = sanitized
        this.htmlInputTarget.value   = sanitized
      })
    }
  }

  disconnect() {
    this.aceEditor.destroy()
  }

  toggleFullscreen(event) {
    if (this.fullScreen === true) {
      this.wrapperTarget.classList.remove(...this.fullScreenClasses)
      this.aceEditor.resize()
      this.aceEditor.focus()
      this.fullScreenIconTarget.setAttribute('data-icon', 'up-right-and-down-left-from-center')
      this.fullScreen = false
    } else {
      this.wrapperTarget.classList.add(...this.fullScreenClasses)
      this.aceEditor.resize()
      this.aceEditor.focus()
      this.fullScreenIconTarget.setAttribute('data-icon', 'down-left-and-up-right-to-center')
      this.fullScreen = true
    }
  }

  updateTextOutput() {
    this.textOutputTarget.textContent = this.textInputTarget.value
  }
}
